import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NestedTable = ({ changeLog }) => {
  const { t } = useTranslation('common');

  // Extract column headings dynamically from the first item in the changeLog array
  const headings = changeLog?.length > 0 ? Object.keys(changeLog[0]) : [];
  const transformedArr = headings.map(item => {
    return item
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase letters
        .replace(/^\w/, c => c.toUpperCase()); // Capitalize the first letter
  });
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {transformedArr.map((heading, index) => (
            <TableCell style={{paddingTop: 0}} key={index}>
              <b>{t(heading.charAt(0).toUpperCase() + heading.slice(1))}</b></TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {changeLog?.map((log, index) => (
         
          <TableRow key={index}>
            {headings?.map((heading, subIndex) => (
              <TableCell key={subIndex} style={{maxWidth: 300, minWidth: 300}}>{heading === "attribute" ? t(log[heading]) : log[heading] || '-'}</TableCell>
            ))}
          </TableRow>
        ))}
        {!changeLog?.length && <TableRow key={0}><TableCell style={{border: 'none'}}>NA</TableCell></TableRow>}
      </TableBody>
    </Table>
  );
};

export default NestedTable;
